export const environment = {
  production: false,
  telemexLink:'https://telemexcm.com/',
};
